import SEO from "components/seo";
import Home from "containers/homev1/homev1";
import { GetServerSideProps } from "next";
import { dehydrate, QueryClient } from "react-query";
import getLanguage from "utils/getLanguage";
import categoryService from "services/category";
import bannerService from "services/banner";
import shopService from "services/shop";
// import recipeService from "services/recipe";

type Props = {};

export default function HomePage({}: Props) {
  return (
    <>
      <SEO />
      <Home />
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async ({
  req,
  // query,
}) => {
  const queryClient = new QueryClient();
  const locale = getLanguage(req.cookies?.locale);
  const isAuthenticated = (req.cookies?.user?.length || 0) > 0;

  await queryClient.prefetchQuery(["shopCategory", locale], () =>
    categoryService.getAllShopCategories({ perPage: 20 }),
  );

  await queryClient.prefetchQuery(["banners", locale], () =>
    bannerService.getAll(),
  );

  await queryClient.prefetchQuery(
    ["visitedShops", locale, isAuthenticated],
    () =>
      shopService.getVisitedShops({
        perPage: 10,
        page: 1,
      }),
  );

  // await queryClient.prefetchQuery(["recipes", locale, query?.category_id], () =>
  //   recipeService.getAll({
  //     perPage: 10,
  //     category_id: query?.category_id,
  //   }),
  // );

  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
    },
  };
};
